import { gridStoreResults } from 'fox-react/dist/components/FoxGrid/actions';
import gridNames from 'common/gridNames';
import CarsManagementSrv from './CarsManagementSrv';

export function storeResults(results) {
  return gridStoreResults(gridNames.carsManagement)(results);
}

export function getForGrid(dataState) {
  return function(dispatch) {
    return CarsManagementSrv.getForGrid(dataState).then(results => {
      dispatch(storeResults(results));
    });
  };
}

export function addAsync(model) {
  return function() {
    return CarsManagementSrv.add(model);
  };
}

export function updateAsync(model) {
  return CarsManagementSrv.update(model);
}
